/**
 * TanStack Router: /documents
 *
 * This route file was auto-generated by the route generation script.
 * Component: DocumentsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import DocumentsPage from '@/app/documents/page'

/**
 * Route: /documents
 * Layout: _auth (authenticated)
 * Component: DocumentsPage
 */
export const Route = createFileRoute('/_auth/documents/')({
  component: DocumentsPage,
})
